import "./ProudProducts.css";
import { items } from "./AllData";
import { Link } from "react-router-dom";

const labelColors = {
  "New": "#aa3d24",
  "Best Seller": "#202d93", 
  "Limited Edition": "#8b9920", 
};

function ProductItem() {
  const filteredItems = items.filter((item) => item.id <= 8);

  return (
    <>
      {filteredItems.map((item) => (
        <div key={item.id} className="product normal">
          {item.label && (
            <div className="product-label"
            style={{
              backgroundColor: labelColors[item.label] || "#D3D3D3",
            }}>
              {item.label}
            </div>
          )}
          <Link
            onClick={() => window.top(0, 0)}
            to={`/categories/product/${item.id}`}
          >
            <div className="product-header">
              <img src={item.img} alt={item.description} />
            </div>
            <div className="product-details">
              <p style={{ color: "black" }}>{item.description}</p>
              <p className="item-price" style={{ color: "black" }}>${item.price}</p>
            </div>
          </Link>
        </div>
      ))}
    </>
  );
}

export default ProductItem;
